import { AsyncPipe, isPlatformBrowser } from '@angular/common';
import {
    Component,
    Inject,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MetadataService } from '@core/services/metadata.service';
import { ReferralService } from '@core/services/referral.service';
import { PublicUser } from '@models/public-user.model';
import { QuicklinkDirective } from 'ngx-quicklink';
import { Observable, Subject, of } from 'rxjs';
import { catchError, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { UserService } from '../../../user/services/user.service';
import { ManualVideoComponent } from '../../../video/components/manual-video/manual-video.component';

@Component({
    selector: 'app-referral-invitation',
    templateUrl: './referral-invitation.component.html',
    styleUrls: ['./referral-invitation.component.css'],
    imports: [ManualVideoComponent, RouterLink, QuicklinkDirective, AsyncPipe],
})
export class ReferralInvitationComponent implements OnInit, OnDestroy {
    referralCode: string;
    destroySubject = new Subject<null>();
    referredBy: Observable<PublicUser>;
    invalidCode: boolean = false;

    constructor(
        private referralService: ReferralService,
        private userService: UserService,
        private metadataService: MetadataService,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    ngOnInit(): void {
        this.metadataService.setColor('#FFFFFF');
        this.metadataService.setAttribute({
            name: 'robots',
            content: 'noindex, nofollow',
        });
        this.handleReferralCode();
    }

    handleReferralCode() {
        this.route.paramMap
            .pipe(takeUntil(this.destroySubject))
            .subscribe(params => {
                const referralCode = params.get('referralCode');
                this.handleReferralCodeInRoute(referralCode);
            });
    }

    handleReferralCodeInRoute(referralCode: string) {
        if (referralCode) {
            this.referredBy = this.userService.profile(referralCode).pipe(
                tap(
                    profile => {
                        if (isPlatformBrowser(this.platformId)) {
                            if (
                                this.referralService.getReferralCode() !==
                                referralCode
                            ) {
                                this.referralService.storeReferralCode(
                                    referralCode
                                );
                                this.referralService
                                    .countReferral()
                                    .pipe(catchError(err => of(null)))
                                    .subscribe();
                            }
                        }
                    },
                    err => {
                        this.invalidCode = true;
                    }
                ),
                catchError(err => of(new PublicUser())),
                shareReplay(1)
            );
        } else {
            this.router.navigate(['/']);
        }
    }

    ngOnDestroy(): void {
        this.destroySubject.next(null);
        this.destroySubject.complete();
    }
}
